import { render, staticRenderFns } from "./UserLevel.vue?vue&type=template&id=db2780e8"
import script from "./UserLevel.vue?vue&type=script&lang=js"
export * from "./UserLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports